<template>
  <div class="option-panel" :class="{ 'active': isActive }" @click="$emit('click', option)">
    <div v-if="option.icon" class="icon-container">
      <base-icon :name="option.icon" />
    </div>
    <template v-else-if="$slots.hasOwnProperty('icon')">
      <slot name="icon" />
    </template>
    <div class="option-info">
      <p class="option-description">
        {{ option.description }}
      </p>
      <p class="option-label">
        {{ option.label }}
      </p>
    </div>
    <div
      v-if="$slots.hasOwnProperty('default')"
      class="option-slot"
      :class="{ single: hasSingleClass }"
      @click.prevent
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'OptionPanel',
  props: {
    option: {
      type: Object,
      required: true,
    },
    noactive: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  computed: {
    isActive() {
      if (this.noactive) {
        return false;
      }

      return this.option.active;
    },
    hasSingleClass() {
      if (this.option.icon) {
        return true;
      }

      return this.$validate.isObjectWithFields(this.$slots, ['icon']);
    },
  },
};
</script>

<style lang="sass" scoped>
  .option-panel
    flex: 1
    display: flex
    flex-wrap: wrap
    padding: 20px
    background: rgba(39, 40, 60, 0.5)
    box-shadow: 0 0 7px rgba(0, 0, 0, 0.15)
    border-radius: 5px

    &.active
      background: #2F3049
      cursor: default

    &:hover
      background: #2F3049
      cursor: pointer

    .icon-container
      width: 40px
      height: 40px
      margin-right: 20px
      flex: none
      display: flex
      justify-content: center
      align-items: center
      background: #1E1D2F
      border-radius: 50%

  .option-info
    width: calc(100% - 60px)
    display: flex
    flex-direction: column
    flex: 1
    overflow: hidden

    +respond-to('small')
      width: auto

  .option-label
    font-size: 12px
    font-weight: 600
    line-height: 20px
    color: #fff
    opacity: 0.5

  .option-description
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis
    font-size: 14px
    font-weight: 500
    line-height: 20px
    color: #fff

  .option-slot
    display: none

    +respond-to('small')
      flex: 1
      text-align: right
      display: block

    &.single
      margin: 0 auto
      padding-top: 10px
      text-align: center

      +respond-to('small')
        margin: 0 0 0 auto
        padding: 0
        text-align: right

    button
      width: 120px
      height: 40px
      display: inline-block
      padding: 0
      font-weight: 500
      font-size: 14px
      line-height: 20px
      background: #27283c !important
      box-shadow: 0 0 4px rgba(0,0,0,.15)
</style>
